import { z } from 'zod/v4';
export const KnowledgeSearchInputSchema = z.object({
    question: z.string(),
    region: z.enum(['US', 'EU', 'WORLD']).default('WORLD'),
    knowledgeGroupIds: z.array(z.string()).optional(),
    fileIds: z.array(z.string()).optional(),
});
const chunkSchema = z.object({
    fileId: z.string(),
    fileName: z.string(),
    group: z.string().optional(),
    content: z.string(),
    pageNumber: z.number(),
});
export const KnowledgeSearchResultSchema = z.object({
    chunks: z.array(chunkSchema),
});
//# sourceMappingURL=knowledge-search.js.map